import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import VoucherEnrollment from '../components/voucher/VoucherEnrollment';
import { RootState } from '../redux/types';

type Props = unknown;

const VoucherEnrollView: React.FC<Props> = () => {
  const navigate = useNavigate();
  const userId = useSelector((state: RootState) => state.users.token?.userId);
  const locale = useSelector((state: RootState) => state.intl.locale);
  const voucherDetail = useSelector((state: RootState) => state.voucher.voucherDetail);

  useEffect(() => {
    if (!voucherDetail) {
      navigate('/redeem');
    }
  }, [navigate, voucherDetail]);

  if (!voucherDetail) {
    return null;
  }
  return (
    <Container
      sx={{
        eight: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{ margin: '0 auto' }}>
        {
          userId
          && (
          <VoucherEnrollment
            voucherDetail={voucherDetail}
            userId={userId}
            locale={locale}
          />
          )
        }
      </div>
    </Container>
  );
};

export default VoucherEnrollView;
